import React, { useState, useEffect } from "react";
import api from "../services/api";
import toast from "react-hot-toast";

export default function Supports() {
  const [supports, setSupports] = useState([]);
  const [cats, setCats] = useState([]);
  const [search, setSearch] = useState("");
  const [statut, setStatut] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ nom:"", code:"", description:"", categorieId:"", statut:"actif", localisation:"", adresse:"", latitude:"", longitude:"", proprietaire:"", valeur:"" });
  const [photo, setPhoto] = useState(null);

  const load = () => {
    const params = {};
    if (search) params.search = search;
    if (statut) params.statut = statut;
    api.get("/supports", { params }).then(r => setSupports(r.data)).catch(() => {});
    api.get("/categories").then(r => setCats(r.data)).catch(() => {});
  };

  useEffect(() => { load(); }, [search, statut]);

  const submit = async e => {
    e.preventDefault();
    try {
      const fd = new FormData();
      fd.append("data", JSON.stringify(form));
      if (photo) fd.append("photo", photo);
      if (editing) {
        await api.put(`/supports/${editing.id}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
        toast.success("Support modifié");
      } else {
        await api.post("/supports", fd, { headers: { "Content-Type": "multipart/form-data" } });
        toast.success("Support créé");
      }
      setShowForm(false); setEditing(null); load();
    } catch(e) { toast.error(e.response?.data?.error || "Erreur"); }
  };

  const del = async id => {
    if (!window.confirm("Supprimer ce support ?")) return;
    await api.delete(`/supports/${id}`);
    toast.success("Supprimé"); load();
  };

  const edit = s => {
    setEditing(s);
    setForm({ nom:s.nom||"", code:s.code||"", description:s.description||"", categorieId:s.categorieId||"",
      statut:s.statut||"actif", localisation:s.localisation||"", adresse:s.adresse||"",
      latitude:s.latitude||"", longitude:s.longitude||"", proprietaire:s.proprietaire||"", valeur:s.valeur||"" });
    setShowForm(true);
  };

  const inp = (label, key, type="text", opts=null) => (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display:"block", fontSize:12, color:"#555", marginBottom:4, fontWeight:600 }}>{label}</label>
      {opts ? (
        <select value={form[key]} onChange={e => setForm({...form, [key]: e.target.value})}
          style={{ width:"100%", padding:"8px 12px", border:"1px solid #ddd", borderRadius:6, fontSize:13 }}>
          {opts.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
        </select>
      ) : (
        <input type={type} value={form[key]} onChange={e => setForm({...form, [key]: e.target.value})}
          style={{ width:"100%", padding:"8px 12px", border:"1px solid #ddd", borderRadius:6, fontSize:13 }} />
      )}
    </div>
  );

  const STATUTS = { actif:"#28a745", inactif:"#6c757d", maintenance:"#F5A800", reforme:"#dc3545" };

  return (
    <div style={{ padding:32 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
        <h1 style={{ fontSize:24, fontWeight:800, color:"#1B3A8C" }}>Supports</h1>
        <button onClick={() => { setShowForm(true); setEditing(null); setForm({ nom:"",code:"",description:"",categorieId:"",statut:"actif",localisation:"",adresse:"",latitude:"",longitude:"",proprietaire:"",valeur:"" }); }}
          style={{ background:"#1B3A8C", color:"#fff", border:"none", borderRadius:8, padding:"10px 20px", fontWeight:700, cursor:"pointer", fontSize:14 }}>
          + Nouveau support
        </button>
      </div>
      <div style={{ display:"flex", gap:12, marginBottom:24 }}>
        <input placeholder="Rechercher..." value={search} onChange={e => setSearch(e.target.value)}
          style={{ flex:1, padding:"10px 14px", border:"1px solid #ddd", borderRadius:8, fontSize:14 }} />
        <select value={statut} onChange={e => setStatut(e.target.value)}
          style={{ padding:"10px 14px", border:"1px solid #ddd", borderRadius:8, fontSize:14 }}>
          <option value="">Tous les statuts</option>
          <option value="actif">Actif</option>
          <option value="inactif">Inactif</option>
          <option value="maintenance">Maintenance</option>
          <option value="reforme">Réformé</option>
        </select>
      </div>
      <div style={{ background:"#fff", borderRadius:12, boxShadow:"0 2px 12px rgba(0,0,0,0.08)", overflow:"hidden" }}>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead>
            <tr style={{ background:"#1B3A8C", color:"#fff" }}>
              {["Code","Nom","Catégorie","Statut","Localisation","Actions"].map(h => (
                <th key={h} style={{ padding:"12px 16px", textAlign:"left", fontSize:13 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {supports.map((s,i) => (
              <tr key={s.id} style={{ background: i%2===0?"#fff":"#f9f9f9", borderBottom:"1px solid #f0f0f0" }}>
                <td style={{ padding:"10px 16px", fontSize:13, fontWeight:700, color:"#1B3A8C" }}>{s.code}</td>
                <td style={{ padding:"10px 16px", fontSize:13 }}>{s.nom}</td>
                <td style={{ padding:"10px 16px", fontSize:13, color:"#666" }}>{s.Categorie?.nom || "-"}</td>
                <td style={{ padding:"10px 16px" }}>
                  <span style={{ background: STATUTS[s.statut]+"22", color:STATUTS[s.statut], padding:"3px 10px", borderRadius:20, fontSize:12, fontWeight:700 }}>{s.statut}</span>
                </td>
                <td style={{ padding:"10px 16px", fontSize:13, color:"#666" }}>{s.localisation || "-"}</td>
                <td style={{ padding:"10px 16px" }}>
                  <button onClick={() => edit(s)} style={{ background:"#F5A800", color:"#fff", border:"none", borderRadius:5, padding:"5px 12px", cursor:"pointer", marginRight:6, fontSize:12 }}>✏️</button>
                  <button onClick={() => del(s.id)} style={{ background:"#dc3545", color:"#fff", border:"none", borderRadius:5, padding:"5px 12px", cursor:"pointer", fontSize:12 }}>🗑️</button>
                  {s.qrCode && <button onClick={() => { const a=document.createElement("a"); a.href=s.qrCode; a.download=`QR-${s.code}.png`; a.click(); }}
                    style={{ background:"#1B3A8C", color:"#fff", border:"none", borderRadius:5, padding:"5px 12px", cursor:"pointer", marginLeft:6, fontSize:12 }}>📥 QR</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {supports.length === 0 && <div style={{ padding:40, textAlign:"center", color:"#aaa" }}>Aucun support trouvé</div>}
      </div>

      {showForm && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center" }}>
          <div style={{ background:"#fff", borderRadius:16, padding:32, width:580, maxHeight:"90vh", overflowY:"auto" }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:20 }}>
              <h2 style={{ color:"#1B3A8C", fontSize:18, fontWeight:700 }}>{editing ? "Modifier le support" : "Nouveau support"}</h2>
              <button onClick={() => setShowForm(false)} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer" }}>✕</button>
            </div>
            <form onSubmit={submit}>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 16px" }}>
                {inp("Nom du support *", "nom")}
                {inp("Code *", "code")}
                {inp("Catégorie", "categorieId", "text", [{ v:"", l:"-- Choisir --"}, ...cats.map(c=>({v:c.id, l:c.nom}))])}
                {inp("Statut", "statut", "text", [{v:"actif",l:"Actif"},{v:"inactif",l:"Inactif"},{v:"maintenance",l:"Maintenance"},{v:"reforme",l:"Réformé"}])}
                {inp("Localisation", "localisation")}
                {inp("Adresse", "adresse")}
                {inp("Latitude", "latitude", "number")}
                {inp("Longitude", "longitude", "number")}
                {inp("Propriétaire", "proprietaire")}
                {inp("Valeur (GNF)", "valeur", "number")}
              </div>
              <div style={{ marginBottom:14 }}>
                <label style={{ display:"block", fontSize:12, color:"#555", marginBottom:4, fontWeight:600 }}>Description</label>
                <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})}
                  style={{ width:"100%", padding:"8px 12px", border:"1px solid #ddd", borderRadius:6, fontSize:13, minHeight:70 }} />
              </div>
              <div style={{ marginBottom:20 }}>
                <label style={{ display:"block", fontSize:12, color:"#555", marginBottom:4, fontWeight:600 }}>Photo</label>
                <input type="file" accept="image/*" onChange={e => setPhoto(e.target.files[0])}
                  style={{ fontSize:13 }} />
              </div>
              <div style={{ display:"flex", gap:12, justifyContent:"flex-end" }}>
                <button type="button" onClick={() => setShowForm(false)}
                  style={{ padding:"10px 20px", border:"1px solid #ddd", borderRadius:8, cursor:"pointer", fontSize:14 }}>Annuler</button>
                <button type="submit"
                  style={{ padding:"10px 24px", background:"#1B3A8C", color:"#fff", border:"none", borderRadius:8, fontWeight:700, cursor:"pointer", fontSize:14 }}>
                  {editing ? "Modifier" : "Créer + QR Code"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
